import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class AboutUs extends Vue {}